import { Theme } from '@mui/material/styles';
import { useModal } from 'mui-modal-provider';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useDeleteContactOwnerFromFollowers } from '../../../sic-lib/api/hooks/useContact';
import { Contact } from '../../../sic-lib/types/Contact';
import { ContactOwner } from '../../../sic-lib/types/ContactOwner';
import { useAppSelector } from '../../../store/hooks';
import DialogConfirmAction from '../../Shared/DialogConfirmAction/DialogConfirmAction';
import { FollowerContainer } from './FollowerContainer';

interface Props {
    contact: Contact;
}

export default function ContactFollowers({ contact }: Props) {
    const { showModal } = useModal();
    const { classes } = useStyles();
    const { mutate: deleteContactOwnerFromFollowers } = useDeleteContactOwnerFromFollowers(
        contact.contactId,
    );
    const contactUsers = React.useMemo(() => {
        return {
            contactOwner: contact.owners.find(contact => contact.isPrimary === true),
            contactFollowers: contact.owners.filter(contact => contact.isPrimary === false),
        };
    }, [contact.owners]);
    const users = useAppSelector(state => state.user.users);

    const handleDelete = async (follower: ContactOwner) => {
        const modal = showModal(DialogConfirmAction, {
            title: 'Confirm Remove Follower',
            description: 'This follower will be removed from contacts’ future notifications.',
            onConfirm: async () => {
                deleteContactOwnerFromFollowers({
                    userName: follower.userName,
                });
            },
            onCancel: () => {
                modal.hide();
            },
        });
    };

    return (
        <>
            {contactUsers.contactFollowers.map(follower => (
                <FollowerContainer
                    key={follower.userName}
                    follower={follower}
                    handleClick={handleDelete}
                    users={users}
                />
            ))}
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
